import { SERVICES_REQUEST as serReq } from './request.config'
import { PER_FORMED_BY, METHOD } from './method.config'
import { STORAGE_KEY } from '../../constants/storage.key'
import { getSafeStorage, readCookie, logMessage, getInitState } from '../../helpers/global'
import { PARAMS as paramsReq } from '../../constants/params'
import { NOT_SET_COOKIE_LIST, ENDPOINT_REQUEST } from './request.config'
import { appConfigConstants } from '@/configurations/app-configs/app.config.constants'
import { store } from '@/configurations'
import { replaceEndSlash } from '@/helpers/global/env.func'
import { Converter, utilsFunction } from '@/helpers/functions'
import { WINVEST_PARAMS_JSON_FLAG, WINVEST_PARAMS_REMOVE_TOKEN, WINVEST_PARAMS_REMOVE_UUID } from '@/constants/win-vest' 

const queryString = require('query-string')

const getInitStateFunc = getInitState({
  TTLWatchlistWinvestServicesVersion: '1.3',
  FUBONWatchlistWinvestServicesVersion: '1.3',
  TTLFlaggingsWinvestServicesBool: true,
  FUBONFlaggingsWinvestServicesBool: true,
})

export const RequestHelper = {
  createAuthorizationHeader,
  createBodyRequest,
  createQueryParamRequest
}

function createAuthorizationHeader(service, action, params, method = '') {
  params = Array.isArray(params) ? params[0] : params
  let headers = {}
  const token = getSafeStorage(STORAGE_KEY.TOKEN)

  if (service === serReq.WIN_VEST) {
    const wXCSRFToken = getSafeStorage(STORAGE_KEY.WIN_VEST_CSRF_TOKEN)
    const wSessionID = getSafeStorage(STORAGE_KEY.WIN_VEST_SESSION)
    const wSessionName = getSafeStorage(STORAGE_KEY.WIN_VEST_SESSION_NAME)
    if (wXCSRFToken) headers['X-CSRF-Token'] = wXCSRFToken
    if (!NOT_SET_COOKIE_LIST.includes(action) && wSessionID && wSessionName) {
      logMessage('New request: ' + service + '/' + action)
      var x = readCookie(decodeURIComponent(wSessionName))
      logMessage('Session Name: ' + wSessionName)
      logMessage('Session ID: ' + x)
      // setCookie(wSessionName, wSessionID)
    }
    if (ENDPOINT_REQUEST.wAUTH.WIN_VEST_LOGOUT === action) {
      headers['Services-User-Logout-Version'] = '1.4'
    } else if (ENDPOINT_REQUEST.wAUTH.WIN_VEST_LOGIN === action) {
      headers['Services-User-Login-Version'] = '1.4'
      delete headers['Services-User-Logout-Version']
    } else if (ENDPOINT_REQUEST.wAUTH.WIN_VEST_MANAGE_WATCHLIST === action) {
      headers['Services-Flag-Update-Version'] = getInitStateFunc('TTLWatchlistWinvestServicesVersion', null, '1.2')
    } else if (params && ENDPOINT_REQUEST.wAUTH.WIN_VEST_ENQUIRY_WATCHLIST.format(params.uuid) === action && getInitStateFunc('TTLFlaggingsWinvestServicesBool')) {
      headers['Services-Flag-Flaggings-Version'] = '1.1'
    }else if (params && params.versiontype ) {
      headers[params.versiontype] = params.versionnum
    }
    headers['Content-Type'] = 'multipart/form-data, application/x-www-form-urlencoded'
    headers['Accept-language'] = 'en-US,en;q=0.9,vi;q=0.8'
    headers['Accept'] = 'application/json,text/html,application/xhtml+xml,application/xml,text/csv;q=0.9,*/*;q=0.8'
    if (params && params[WINVEST_PARAMS_JSON_FLAG.KEY] === WINVEST_PARAMS_JSON_FLAG.VALUE) {
      headers['Content-Type'] = 'application/json'
    }
  } else {
    if(method === METHOD.GET ){
      headers['Services-Pass'] = token
    }
    if (params[STORAGE_KEY.SET_HEADER]) {
      headers[PER_FORMED_BY] = params[STORAGE_KEY.SET_HEADER]
      delete params.SET_HEADER
    }
    headers['Content-Type'] = 'application/json'
    headers['Accept-language'] = 'en-US,en;q=0.9,vi;q=0.8'
    headers['Accept'] = 'application/json,text/html,application/xhtml+xml,application/xml,text/csv;q=0.9,*/*;q=0.8'
  }
  return headers
}

function createBodyRequest(service, action, params) {
  let rootURL = replaceEndSlash(service === serReq.WIN_VEST ? appConfigConstants.winvestorAPI : appConfigConstants.itradeAPI)

  let postData = {}
  if (service !== '') rootURL = rootURL + service + '/'
  rootURL = rootURL + action

  if (Array.isArray(params)) {
    postData = JSON.stringify(params.map(param => {
      const newParams = JSON.parse(JSON.stringify(param))
      delete newParams[WINVEST_PARAMS_JSON_FLAG.KEY]
      return newParams
    }))
  } else if (service === serReq.WIN_VEST) {
    const copyParams = JSON.parse(JSON.stringify(params))
    const wAccessToken = getSafeStorage(STORAGE_KEY.WIN_VEST_ACCESS_TOKEN)
    if (wAccessToken) params[paramsReq.TOKEN] = wAccessToken

    if (params[WINVEST_PARAMS_REMOVE_TOKEN.KEY] === WINVEST_PARAMS_REMOVE_TOKEN.VALUE) {
      delete copyParams[WINVEST_PARAMS_REMOVE_TOKEN.KEY]
      delete copyParams[paramsReq.TOKEN]
    }

    if (params[WINVEST_PARAMS_REMOVE_UUID.KEY] === WINVEST_PARAMS_REMOVE_UUID.VALUE) {
      delete copyParams[WINVEST_PARAMS_REMOVE_UUID.KEY]
      delete copyParams['uuid']
    }

    if (params[WINVEST_PARAMS_JSON_FLAG.KEY] === WINVEST_PARAMS_JSON_FLAG.VALUE) {
      delete copyParams[WINVEST_PARAMS_JSON_FLAG.KEY]
      postData = JSON.stringify(copyParams)
    } else {
      postData = queryString.stringify(copyParams)
    }
  } else {
    const { clientID, tradingAccSeq } = store.getState().trade.currentTradingAccount
    const token = getSafeStorage(STORAGE_KEY.TOKEN)
    if (token) params[paramsReq.TOKEN] = token
    if (tradingAccSeq) params[paramsReq.TRADING_ACC_SEQ] = String(tradingAccSeq)
    if (clientID) {
      params[paramsReq.CLIENT_ID] = clientID
      params[paramsReq.TRADING_ACCOUNT_ID] = clientID
    }
    postData = JSON.stringify(params)
  }

  let language = store.getState().app.language.lang
  language = service === serReq.WIN_VEST ? Converter.mappingWinVestLanguage(language) : language
  return {
    url: utilsFunction.joinUrlParams(rootURL, { language }),
    params: postData
  }
}

function createQueryParamRequest(service, action, params) {
  let rootURL = replaceEndSlash(service === serReq.WIN_VEST ? appConfigConstants.winvestorAPI : appConfigConstants.itradeAPI)

  if (service === serReq.WIN_VEST) {
    if (params && params !== undefined) {
      const wAccessToken = getSafeStorage(STORAGE_KEY.WIN_VEST_ACCESS_TOKEN)
      if (wAccessToken) params[paramsReq.TOKEN] = wAccessToken
    }
  } else {
    const { clientID, tradingAccSeq } = store.getState().trade.currentTradingAccount
    if (params && params !== undefined) {
      // const token = getSafeStorage(STORAGE_KEY.TOKEN)
      // if (token) params[paramsReq.TOKEN] = token
      if (tradingAccSeq) params[paramsReq.TRADING_ACC_SEQ] = String(tradingAccSeq)
      // if (clientID) {
      //   params[paramsReq.CLIENT_ID] = clientID
      //   params[paramsReq.TRADING_ACCOUNT_ID] = clientID
      // }
      if(params.token){
        delete params.token
      }
      if(params.clientID){
        delete params.clientID
      }
      if(params.tradingAccountId){
        delete params.tradingAccountId
      }
    }
  }
  if (service !== '') rootURL = rootURL + service + '/'
  rootURL = rootURL + action
  if (params && params !== undefined) {
    let paramsArray = []
    Object.keys(params).forEach(key => paramsArray.push(key + '=' + params[key]))
    if (rootURL.search(/\?/) === -1) {
      rootURL += '?' + paramsArray.join('&')
    } else {
      rootURL += '&' + paramsArray.join('&')
    }
  }

  let language = store.getState().app.language.lang
  language = service === serReq.WIN_VEST ? Converter.mappingWinVestLanguage(language) : language

  return {
    url: utilsFunction.joinUrlParams(rootURL, { language })
  }
}
